/**
 * Custom JavaScript – See Spot Run (SSR) theme
 * Shopify best practices: IIFE, progressive enhancement, data attributes for config.
 * Keep bundle small; use only for enhancements beyond default theme behavior.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function initVariantInfoUpdater() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    var unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var data = ev && ev.data;
      var variant = data && data.variant;
      var sectionId = data && data.sectionId;
      if (!variant || !sectionId) return;

      var container = document.getElementById('VariantInfo-' + sectionId);
      var dataEl = document.getElementById('VariantInfoData-' + sectionId);
      if (!container || !dataEl) return;

      var parsed;
      try {
        parsed = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var variantData = parsed.variants && parsed.variants[String(variant.id)];
      if (!variantData) return;

      var titleEl = container.querySelector('.product__variant-info-title');
      var metafieldEl = container.querySelector('.product__variant-info-metafield');
      if (titleEl) titleEl.textContent = variantData.title || '';
      if (metafieldEl) {
        metafieldEl.textContent = variantData.breed_info || '';
        metafieldEl.style.display = variantData.breed_info ? '' : 'none';
      } else if (variantData.breed_info) {
        var span = document.createElement('span');
        span.className = 'product__variant-info-metafield';
        span.textContent = variantData.breed_info;
        container.appendChild(span);
      }
    });

    if (typeof document.addEventListener === 'function') {
      document.addEventListener('shopify:section:unload', function (e) {
        if (e.detail && e.detail.sectionId) {
          unsub();
        }
      });
    }
  }

  ready(function () {
    initVariantInfoUpdater();
  });
})();
